const pointCloudRequests = {
  getPointCloudAccessTokenRequest: ({ pageId } = {}) => ({
    url: `api/pages/${pageId}/potreePointCloudSas`,
    method: 'get',
  }),
  getPointCloudSettingsRequest: ({ pageId }) => ({
    url: `api/pages/${pageId}/pointCloudSettings`,
    method: 'get',
  }),
  updatePointCloudSettingsRequest: ({ pageId, settings }) => ({
    url: `api/pages/${pageId}/pointCloudSettings`,
    method: 'put',
    data: settings,
  }),
  get3DModelsRequest: () => ({
    url: `api/threeDModels`,
    method: 'get',
  }),
  create3DModelRequest: ({ model }) => ({
    url: `api/threeDModels`,
    method: 'post',
    data: model,
  }),
  delete3DModelRequest: ({ id }) => ({
    url: `api/threeDModels/${id}`,
    method: 'delete',
  }),
  createSplatModelRequest: (data) => ({
    url: `api/threeDModels/splat`,
    method: 'post',
    data,
  }),
  prepareCreateSplatModelRequest: (data) => ({
    url: `api/threeDModels/splat/prepare`,
    method: 'post',
    data,
  }),
}

export default pointCloudRequests
